import * as React from 'react';

function SvgDay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 497.61 489.67"
      {...props}
    >
      <path d="M200.57 115.56a83.32 83.32 0 1083.32 83.32 83.41 83.41 0 00-83.32-83.32zM93.06 117.62a18.533 18.533 0 1026.21-26.21L85.32 57.46a18.53 18.53 0 10-26.21 26.2zM308 280.14a18.533 18.533 0 00-26.21 26.21l34 33.95a18.53 18.53 0 0026.2-26.21zM294.9 123.04a18.46 18.46 0 0013.1-5.42l33.95-34a18.53 18.53 0 00-26.2-26.21l-34 34a18.53 18.53 0 0013.11 31.63zM93.06 280.14l-33.95 33.95a18.53 18.53 0 1026.21 26.18l33.95-33.95a18.533 18.533 0 00-26.21-26.21zM66.57 218.64a18.53 18.53 0 100-37.06h-48a18.53 18.53 0 000 37.06zM333.45 181.58a18.53 18.53 0 100 37.06h48a18.53 18.53 0 100-37.06zM213.06 79.65a18.48 18.48 0 005.39-13.11v-48a18.54 18.54 0 00-37.07 0v48a18.56 18.56 0 0031.68 13.1zM181.38 333.45v48a18.54 18.54 0 1037.07 0v-48a18.54 18.54 0 00-37.07 0zM497.57 395.42a94.66 94.66 0 01-179.61 41.36 3.79 3.79 0 015.08-5.07 86.15 86.15 0 0038.34 9.08 87.19 87.19 0 0087.47-86.71 86.11 86.11 0 00-8.94-38.8 3.78 3.78 0 015.08-5.06 94.08 94.08 0 0152.58 85.2z" />
    </svg>
  );
}

export default SvgDay;
